import React from 'react';
import { FlexibleCol } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { GridRowStyled } from '@yme/components/SearchPage/styled';
import { INDENT } from '@yme/tokens/sizes';
import { buildKey } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
export function ModelsGridSkeleton() {
    const cardsArr = Array(9).fill('modelsGridSkeletonItem');
    return (React.createElement(React.Fragment, null,
        React.createElement(GridRowStyled, null,
            React.createElement(FlexibleCol, { smMargin: "0 0 40px 0" },
                React.createElement(Skeleton, { skeletonProps: {
                        height: 72,
                        style: {
                            paddingBottom: '24px',
                        },
                    } }))),
        React.createElement(GridRowStyled, null, cardsArr.map((item, index) => (React.createElement(FlexibleCol, { smMargin: `0 0 ${INDENT.m} 0`, sm: 6, md: 4, lg: 4, key: buildKey(item, index) },
            React.createElement(Skeleton, { skeletonProps: {
                    style: {
                        aspectRatio: AspectRatio.Square,
                    },
                } }),
            React.createElement(Skeleton, { skeletonProps: {
                    height: 28,
                    style: {
                        marginTop: INDENT.xs,
                        width: '50%',
                    },
                } }),
            React.createElement(Skeleton, { skeletonProps: {
                    height: 24,
                    style: {
                        marginTop: INDENT.xxxxs,
                        width: '50%',
                    },
                } })))))));
}
